<!-- Main Header -->
<header>
    <mat-card>
      <mat-card-content>
        <div fxLayout="row">
          <div fxFlex="">
            <button mat-icon-button (click)="onBackClick()">
              <mat-icon>arrow_back</mat-icon>
            </button>
          </div>
          <div fxFlex="100" fxLayoutAlign="center">
            <h1 class="mat-h1">{{title}}</h1>
          </div>
          <div fxFlex="" fxLayoutAlign="end">
            <button mat-icon-button (click)="onCrossClick()"  *ngIf="!_commonService.isFromBrokerMobileApp">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <!-- Progress Bar -->
    <mat-progress-bar mode="determinate" value="{{progress}}"></mat-progress-bar>
  </header>